document.addEventListener("DOMContentLoaded", () => {
  function updateSliderPosition() {
    const activeTab = document.querySelector('.tabbed-content__nav-item--active');
    const indicator = document.querySelector('.tabbed-content__nav-indicator');

    if (activeTab && indicator) {
      const tabWidth = activeTab.offsetWidth;
      const tabLeft = activeTab.offsetLeft;

      indicator.style.setProperty('--indicator-width', `${tabWidth}px`);
      indicator.style.setProperty('--indicator-left', `${tabLeft}px`);
    }
  }

  const tabContainers = document.querySelectorAll(".tabbed-content:not([data-initialized='true'])");

  tabContainers.forEach((container) => {
    container.setAttribute("data-initialized", "true");

    const buttons = container.querySelectorAll(".tabbed-content__nav-item");
    const panels = container.querySelector(".tabbed-content__content").children;

    Array.from(panels).forEach((panel, index) => {
      panel.classList.add("tab-panel");
      if (index === 0) {
        panel.classList.add("tab-panel--active");
        panel.style.display = "block";
      } else {
        panel.style.display = "none";
      }
    });

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.classList.contains("tabbed-content__nav-item--active")) return;

        const targetIndex = button.getAttribute("data-tab");
        const currentActiveButton = container.querySelector(".tabbed-content__nav-item--active");

        if (currentActiveButton) {
          currentActiveButton.classList.remove("tabbed-content__nav-item--active");
        }
        button.classList.add("tabbed-content__nav-item--active");

        const activePanel = container.querySelector(".tab-panel--active");
        const newPanel = panels[targetIndex];

        if (activePanel) {
          activePanel.classList.remove("tab-panel--active");

          setTimeout(() => {
            activePanel.style.display = "none";
            newPanel.style.display = "block";

            setTimeout(() => {
              newPanel.classList.add("tab-panel--active");
            }, 10);

          }, 300);
        }
      });
    });
  });

    document.addEventListener('DOMContentLoaded', updateSliderPosition);
  updateSliderPosition();
});